import { render } from "./ProductComfirmObsoleteDialogButton.vue?vue&type=template&id=63cc9d71"
import script from "./ProductComfirmObsoleteDialogButton.vue?vue&type=script&lang=js"
export * from "./ProductComfirmObsoleteDialogButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__